export const lang = {
  en: {
    // Header
    headerHome: "Home",
    headerAbout: "About",
    headerProjects: "Projects",
    headerContacts: "Contacts",
    headerLogout: "Logout",
    headerLogin: "Login",

    // Home page
    Headername: "SUN4S",
    Maintext: "Hi, I'm Saftar, a creative",
    Maintexttwo: "Front-End Developer",
    Creative: "CREATIVE",
    Experience: "EXPERIENCE",
    Projects: "PROJECTS",
    Development: "DEVELOPMENT",
    MainExprience: "I'm eager to become an expert programmer",
    EducationalAward: "I HAVE STARTED MY CAREER",

    // Experience section
    yearsOfExperience: "YEARS OF EXPERIENCE",
    projectsCompleted: "PROJECTS COMPLETED",
    happyClients: "HAPPY CLIENTS",

    // Skills section
    mySkills: "MY SKILLS",
    skillsTitle: "What I can do",
    htmlCss: "HTML & CSS",
    javascript: "JAVASCRIPT",
    react: "REACT",
    nodeJs: "NODE.JS",
    typescript: "TYPESCRIPT",
    git: "GIT",
    figma: "FIGMA",
    responsive: "RESPONSIVE DESIGN",

    // About page
    AboutName: "SUN4S",
    AboutLastName: "Aliev",
    frontendDeveloper: "Frontend Developer",
    buildingModern: "Building modern and responsive web applications",
    developerDescription:
      "Passionate developer with a strong focus on creating clean, efficient code and exceptional user experiences. I enjoy solving complex problems and learning new technologies.",
    experience: "Experience",
    education: "Education",
    skills: "Skills",

    // Projects
    ProducText: "Lead product designer and art director.",
    AboutTextMain:
      "I am a professional product designer with more than 10 years of experience. I have a passion for design with a purpose. If you're looking for a designer to help you reach your specific business needs, I can help you achieve that.",
    Allwork: "All",
    Design: "Design",
    Branding: "Branding",
    Figma: "Figma",

    // Services/Skills/Education
    ProducNumber: "PRODUCT DESIGNER (2018 — Present)",
    AwardsNumber: "WEB DEVELOPER (2018 — 2019)",
    WoodNumber: "Project Specialist (2015 — 2018)",
    AwardsRegion: "AWARDS & RECOGNITION",
    EducationHeader: "Education and qualification",
    EducationRegion: "Where I learned my skills",
    Services: "SERVICES",
    HappyCustomer: "TECH SKILLS",

    // Footer
    FooterLefttext: "© 2024 All rights reserved",

    // Other sections
    contactTitle: "Contact with me",
    contactSubtitle: "Get in touch",
    messagePlaceholder: "Your message",
    sendButton: "Send",
    projectsTitle: "Projects",
    projectsSubtitle: "Recent works",
    viewDemo: "View Demo",
    viewCode: "View Code",
    technologies: "Technologies I use",

    // Services section
    servicesTitle: "My Services",
    servicesSubtitle: "What I can do for you",
    serviceWebDev: "Web Developer",
    serviceWebDevDesc:
      "Every single project is a challenge that I accept eagerly. Let's implement innovative ideas together!",
    serviceWebDesign: "Web Design",
    serviceWebDesignDesc: "Each design is a beautiful and user-friendly site!",
    serviceUiUx: "UI/UX Design",
    serviceUiUxDesc:
      "In every design, everything is important, down to the pixels.",
    serviceArtDirection: "Art Direction",
    serviceArtDirectionDesc: "You can't have a beautiful website without art!",

    // About Me section
    aboutTitle: "About Me",
    aboutSubtitle: "My introduction",
    aboutBornIn: "BORN IN",
    aboutAzerbaijan: "AZERBAIJAN",
    aboutExperience: "EXPERIENCE",
    aboutExperienceYears: "+3 Years",
    aboutLocation: "Location",
    aboutStockholm: "Stockholm",
    aboutDescription:
      "Front-end developer, I create web pages with UI / UX user interface, I have years of experience and many clients are happy with the projects carried out.",
    aboutDownloadCV: "Download CV",

    // Projects section
    usedTechnologies: "Used technologies",
    frontendCategory: "Front-end",

    // Project descriptions
    filmotekaDesc:
      "The website allows users to search for movies, view detailed descriptions, and save favorites.",
    filmotekaHighlights:
      "Filmoteka is a web application for searching and viewing movie information. It uses The Movie Database (TMDB) API to fetch data about movies, including descriptions, ratings, posters, and genres.",

    eleanshopDesc:
      "The website provides a seamless shopping experience, allowing users to explore products, add them to the cart, and proceed to checkout",
    eleanshopHighlights:
      "The website is built using HTML for structuring content, SCSS for advanced styling and better maintainability, JavaScript (ES6+) to handle interactive elements and dynamic functionality, and Webpack for module bundling and performance optimization.",

    hellEnglishDesc:
      "Hellen English is an educational website designed to help users learn English. It features an intuitive interface, structured lessons, and interactive elements for an engaging learning experience.",
    hellEnglishHighlights:
      "The website is built using HTML for structuring content, SCSS for advanced styling and better maintainability, JavaScript (ES6+) to handle interactive elements and dynamic functionality",

    webStudioDesc:
      "The GoIT Markup HW-08 project is a responsive multi-page website designed with modern web technologies to ensure a clean layout, smooth interactivity, and accessibility on different devices.",
    webStudioHighlights:
      "The website is built using HTML for structuring content, SCSS for advanced styling and better maintainability, JavaScript (ES6+) to handle interactive elements and dynamic functionality, and CSS Flexbox & Grid for responsive design.",

    inventoryDesc:
      "The website allows users to manage inventory, add products, and track stock levels.",
    inventoryHighlights:
      "The website is built using React, Redux, HTML, SCSS, and Styled Components for a clean and responsive design.",

    // Chat and messages
    chatBack: "← Back",
    chatSupportTitle: "Support Chat",
    chatWithUser: "Chat with user",
    chatAdminReply: "You are replying as administrator",
    chatDeleteChat: "Delete Chat",
    chatLoading: "Loading all messages...",
    chatNoMessages: "No messages found",
    chatMessagePlaceholder: "Enter message...",
    chatSend: "Send",
    chatDeleteConfirm: "Delete Confirmation",
    chatDeleteSure: "Are you sure you want to delete this chat?",
    chatDeletePermanent: "All messages will be permanently deleted.",
    chatCancel: "Cancel",
    chatDelete: "Delete",
    chatDeleting: "Deleting...",

    // User chats
    chatUserChats: "User Chats",
    chatTechSupport: "Technical Support",
    chatNoUsers: "No users to connect with yet.",
    chatOpenChat: "Open Chat",
    chatStartChat: "Start Chat",
    chatAdminMessage:
      "You are logged in as administrator. You can communicate with all system users.",
    chatNoAdmins: "No administrators found. Please contact technical support.",
    chatAdministrator: "Administrator",
    chatOpenSupport: "Open Support Chat",
    chatContactSupport: "Contact Support",
    chatSupportMessage:
      "In this section you can contact the administrator for assistance.",

    // Contacts
    contactsTitle: "Contacts",
    contactsChats: "Chats",

    // Login and registration
    loginTab: "Login",
    registerTab: "Register",
    loginWithGoogle: "Sign in with Google",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    loginButton: "Login",
    registerButton: "Register",
    loginError: "Login error",
    registerError: "Registration error",
  },
  ru: {
    // Header
    headerHome: "Главная",
    headerAbout: "Обо мне",
    headerProjects: "Проекты",
    headerContacts: "Контакты",
    headerLogout: "Выйти",
    headerLogin: "Войти",

    // Home page
    Headername: "SUN4S",
    Maintext: "Привет, я Сафтар,",
    Maintexttwo: "Фронтенд Разработчик",
    Creative: "КРЕАТИВНЫЙ",
    Experience: "ОПЫТ",
    Projects: "ПРОЕКТЫ",
    Development: "РАЗРАБОТКА",
    MainExprience: "Я стремлюсь стать экспертом в программировании",
    EducationalAward: "Я НАЧАЛ СВОЮ КАРЬЕРУ",

    // Experience section
    yearsOfExperience: "ЛЕТ ОПЫТА",
    projectsCompleted: "ЗАВЕРШЕННЫХ ПРОЕКТОВ",
    happyClients: "ДОВОЛЬНЫХ КЛИЕНТОВ",

    // Skills section
    mySkills: "МОИ НАВЫКИ",
    skillsTitle: "Что я умею делать",
    htmlCss: "HTML и CSS",
    javascript: "JAVASCRIPT",
    react: "REACT",
    nodeJs: "NODE.JS",
    typescript: "TYPESCRIPT",
    git: "GIT",
    figma: "FIGMA",
    responsive: "АДАПТИВНЫЙ ДИЗАЙН",

    // About page
    AboutLastName: "Алиев",
    AboutName: "Сафтар",
    frontendDeveloper: "Frontend Разработчик",
    buildingModern: "Создаю современные и отзывчивые веб-приложения",
    developerDescription:
      "Увлеченный разработчик с сильным акцентом на создание чистого, эффективного кода и исключительного пользовательского опыта. Я люблю решать сложные задачи и изучать новые технологии.",
    experience: "Опыт",
    education: "Образование",
    skills: "Навыки",

    // Projects
    ProducText: "Ведущий продуктовый дизайнер и арт-директор.",
    AboutTextMain:
      "Я профессиональный продуктовый дизайнер с более чем 10-летним опытом. Я увлечен дизайном с целью. Если вы ищете дизайнера, чтобы помочь вам достичь ваших конкретных бизнес-потребностей, я могу помочь вам в этом.",
    Allwork: "Все",
    Design: "Дизайн",
    Branding: "Брендинг",
    Figma: "Фигма",

    // Services/Skills/Education
    ProducNumber: "ПРОДУКТОВЫЙ ДИЗАЙНЕР (2018 — н.в.)",
    AwardsNumber: "ВЕБ-РАЗРАБОТЧИК (2018 — 2019)",
    WoodNumber: "Специалист по проектам (2015 — 2018)",
    AwardsRegion: "НАГРАДЫ И ПРИЗНАНИЯ",
    EducationHeader: "Образование и квалификация",
    EducationRegion: "Где я приобрел свои навыки",
    Services: "УСЛУГИ",
    HappyCustomer: "ТЕХНИЧЕСКИЕ НАВЫКИ",

    // Footer
    FooterLefttext: "© 2024 Все права защищены",

    // Other sections
    contactTitle: "Свяжитесь со мной",
    contactSubtitle: "Оставьте сообщение",
    messagePlaceholder: "Ваше сообщение",
    sendButton: "Отправить",
    projectsTitle: "Проекты",
    projectsSubtitle: "Недавние работы",
    viewDemo: "Демо",
    viewCode: "Код",
    technologies: "Технологии, которые я использую",

    // Services section
    servicesTitle: "Мои Услуги",
    servicesSubtitle: "Что я могу для вас сделать",
    serviceWebDev: "Веб-разработчик",
    serviceWebDevDesc:
      "Каждый проект - это вызов, который я с радостью принимаю. Давайте реализуем инновационные идеи вместе!",
    serviceWebDesign: "Веб-дизайн",
    serviceWebDesignDesc: "Каждый дизайн - это красивый и удобный сайт!",
    serviceUiUx: "UI/UX Дизайн",
    serviceUiUxDesc: "В каждом дизайне важно всё, вплоть до пикселей.",
    serviceArtDirection: "Арт-директор",
    serviceArtDirectionDesc: "Невозможно создать красивый сайт без искусства!",

    // About Me section
    aboutTitle: "Обо мне",
    aboutSubtitle: "Моё представление",
    aboutBornIn: "РОДИЛСЯ В",
    aboutAzerbaijan: "АЗЕРБАЙДЖАНЕ",
    aboutExperience: "ОПЫТ",
    aboutExperienceYears: "+3 года",
    aboutLocation: "Локация",
    aboutStockholm: "Стокгольм",
    aboutDescription:
      "Фронтенд-разработчик, я создаю веб-страницы с пользовательским интерфейсом UI/UX, у меня есть многолетний опыт, и многие клиенты довольны выполненными проектами.",
    aboutDownloadCV: "Скачать резюме",

    // Projects section
    usedTechnologies: "Использованные технологии",
    frontendCategory: "Фронтенд",

    // Project descriptions
    filmotekaDesc:
      "Сайт позволяет пользователям искать фильмы, просматривать подробные описания и сохранять избранное.",
    filmotekaHighlights:
      "Filmoteka - это веб-приложение для поиска и просмотра информации о фильмах. Оно использует API The Movie Database (TMDB) для получения данных о фильмах, включая описания, рейтинги, постеры и жанры.",

    eleanshopDesc:
      "Сайт обеспечивает удобный процесс покупок, позволяя пользователям просматривать товары, добавлять их в корзину и переходить к оформлению заказа.",
    eleanshopHighlights:
      "Сайт создан с использованием HTML для структурирования контента, SCSS для продвинутой стилизации и лучшей поддерживаемости, JavaScript (ES6+) для обработки интерактивных элементов и динамической функциональности, а также Webpack для сборки модулей и оптимизации производительности.",

    hellEnglishDesc:
      "Hellen English - это образовательный сайт, предназначенный для изучения английского языка. Он имеет интуитивно понятный интерфейс, структурированные уроки и интерактивные элементы для увлекательного обучения.",
    hellEnglishHighlights:
      "Сайт создан с использованием HTML для структурирования контента, SCSS для продвинутой стилизации и лучшей поддерживаемости, JavaScript (ES6+) для обработки интерактивных элементов и динамической функциональности.",

    webStudioDesc:
      "Проект GoIT Markup HW-08 - это адаптивный многостраничный сайт, разработанный с использованием современных веб-технологий для обеспечения чистого макета, плавной интерактивности и доступности на разных устройствах.",
    webStudioHighlights:
      "Сайт создан с использованием HTML для структурирования контента, SCSS для продвинутой стилизации и лучшей поддерживаемости, JavaScript (ES6+) для обработки интерактивных элементов и динамической функциональности, а также CSS Flexbox и Grid для адаптивного дизайна.",

    inventoryDesc:
      "Сайт позволяет пользователям управлять инвентарем, добавлять продукты и отслеживать уровень запасов.",
    inventoryHighlights:
      "Сайт создан с использованием React, Redux, HTML, SCSS и Styled Components для чистого и адаптивного дизайна.",

    // Chat and messages
    chatBack: "← Назад",
    chatSupportTitle: "Чат поддержки",
    chatWithUser: "Чат с пользователем",
    chatAdminReply: "Вы отвечаете как администратор",
    chatDeleteChat: "Удалить чат",
    chatLoading: "Загрузка сообщений...",
    chatNoMessages: "Сообщений не найдено",
    chatMessagePlaceholder: "Введите сообщение...",
    chatSend: "Отправить",
    chatDeleteConfirm: "Подтверждение удаления",
    chatDeleteSure: "Вы уверены, что хотите удалить этот чат?",
    chatDeletePermanent: "Все сообщения будут удалены безвозвратно.",
    chatCancel: "Отмена",
    chatDelete: "Удалить",
    chatDeleting: "Удаление...",

    // User chats
    chatUserChats: "Чаты пользователей",
    chatTechSupport: "Техническая поддержка",
    chatNoUsers: "Пока нет пользователей для связи.",
    chatOpenChat: "Открыть чат",
    chatStartChat: "Начать чат",
    chatAdminMessage:
      "Вы вошли как администратор. Вы можете общаться со всеми пользователями системы.",
    chatNoAdmins:
      "Администраторы не найдены. Пожалуйста, обратитесь в техническую поддержку.",
    chatAdministrator: "Администратор",
    chatOpenSupport: "Открыть чат поддержки",
    chatContactSupport: "Связаться с поддержкой",
    chatSupportMessage:
      "В этом разделе вы можете связаться с администратором для получения помощи.",

    // Contacts
    contactsTitle: "Контакты",
    contactsChats: "Чаты",

    // Login and registration
    loginTab: "Вход",
    registerTab: "Регистрация",
    loginWithGoogle: "Войти через Google",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Пароль",
    loginButton: "Войти",
    registerButton: "Зарегистрироваться",
    loginError: "Ошибка входа",
    registerError: "Ошибка регистрации",
  },
  ua: {
    // Header
    headerHome: "Головна",
    headerAbout: "Про мене",
    headerProjects: "Проекти",
    headerContacts: "Контакти",
    headerLogout: "Вийти",
    headerLogin: "Увійти",

    // Home page
    Headername: "SUN4S",
    Maintext: "Привіт, я Сафтар,",
    Maintexttwo: "Фронтенд Розробник",
    Creative: "КРЕАТИВНИЙ",
    Experience: "ДОСВІД",
    Projects: "ПРОЕКТИ",
    Development: "РОЗРОБКА",
    Webflow: "ВЕБФЛОУ",
    MainExprience: "Я прагну стати експертом у програмуванні",
    EducationalAward: "Я РОЗПОЧАВ СВОЮ КАР'ЄРУ",

    // Experience section
    yearsOfExperience: "РОКІВ ДОСВІДУ",
    projectsCompleted: "ЗАВЕРШЕНИХ ПРОЕКТІВ",
    happyClients: "ЗАДОВОЛЕНИХ КЛІЄНТІВ",

    // Skills section
    mySkills: "МОЇ НАВИЧКИ",
    skillsTitle: "Що я вмію робити",
    htmlCss: "HTML і CSS",
    javascript: "JAVASCRIPT",
    react: "REACT",
    nodeJs: "NODE.JS",
    typescript: "TYPESCRIPT",
    git: "GIT",
    figma: "FIGMA",
    responsive: "АДАПТИВНИЙ ДИЗАЙН",

    // About page
    AboutLastName: "Алієв",
    AboutName: "Сафтар",
    frontendDeveloper: "Frontend Розробник",
    buildingModern: "Створюю сучасні та адаптивні веб-додатки",
    developerDescription:
      "Захоплений розробник з сильним акцентом на створення чистого, ефективного коду та виняткового користувацького досвіду. Я люблю вирішувати складні задачі та вивчати нові технології.",
    experience: "Досвід",
    education: "Освіта",
    skills: "Навички",

    // Projects
    ProducText: "Провідний продуктовий дизайнер та арт-директор.",
    AboutTextMain:
      "Я професійний продуктовий дизайнер з більш ніж 10-річним досвідом. Я захоплений дизайном з метою. Якщо ви шукаєте дизайнера, щоб допомогти вам досягти ваших конкретних бізнес-потреб, я можу допомогти вам у цьому.",
    Allwork: "Всі",
    Design: "Дизайн",
    Branding: "Брендинг",
    Figma: "Фігма",

    // Services/Skills/Education
    ProducNumber: "ПРОДУКТОВИЙ ДИЗАЙНЕР (2018 — т.ч.)",
    AwardsNumber: "ВЕБ-РОЗРОБНИК (2018 — 2019)",
    WoodNumber: "Спеціаліст з проектів (2015 — 2018)",
    AwardsRegion: "НАГОРОДИ ТА ВИЗНАННЯ",
    EducationHeader: "Освіта та кваліфікація",
    EducationRegion: "Де я здобув свої навички",
    Services: "ПОСЛУГИ",
    HappyCustomer: "ТЕХНІЧНІ НАВИЧКИ",

    // Footer
    FooterLefttext: "© 2024 Всі права захищені",

    // Other sections
    contactTitle: "Зв'яжіться зі мною",
    contactSubtitle: "Залиште повідомлення",
    messagePlaceholder: "Ваше повідомлення",
    sendButton: "Надіслати",
    projectsTitle: "Проекти",
    projectsSubtitle: "Останні роботи",
    viewDemo: "Демо",
    viewCode: "Код",
    technologies: "Технології, які я використовую",

    // Services section
    servicesTitle: "Мої Послуги",
    servicesSubtitle: "Що я можу для вас зробити",
    serviceWebDev: "Веб-розробник",
    serviceWebDevDesc:
      "Кожен проект - це виклик, який я з радістю приймаю. Давайте реалізуємо інноваційні ідеї разом!",
    serviceWebDesign: "Веб-дизайн",
    serviceWebDesignDesc: "Кожен дизайн - це красивий і зручний сайт!",
    serviceUiUx: "UI/UX Дизайн",
    serviceUiUxDesc: "У кожному дизайні важливо все, аж до пікселів.",
    serviceArtDirection: "Арт-директор",
    serviceArtDirectionDesc: "Неможливо створити красивий сайт без мистецтва!",

    // About Me section
    aboutTitle: "Про мене",
    aboutSubtitle: "Моє представлення",
    aboutBornIn: "НАРОДИВСЯ В",
    aboutAzerbaijan: "АЗЕРБАЙДЖАНІ",
    aboutExperience: "ДОСВІД",
    aboutExperienceYears: "+3 роки",
    aboutLocation: "Локація",
    aboutStockholm: "Стокгольм",
    aboutDescription:
      "Фронтенд-розробник, я створюю веб-сторінки з користувацьким інтерфейсом UI/UX, у мене є багаторічний досвід, і багато клієнтів задоволені виконаними проектами.",
    aboutDownloadCV: "Завантажити резюме",

    // Projects section
    usedTechnologies: "Використані технології",
    frontendCategory: "Фронтенд",

    // Project descriptions
    filmotekaDesc:
      "Сайт дозволяє користувачам шукати фільми, переглядати детальні описи та зберігати улюблені.",
    filmotekaHighlights:
      "Filmoteka - це веб-додаток для пошуку та перегляду інформації про фільми. Він використовує API The Movie Database (TMDB) для отримання даних про фільми, включаючи описи, рейтинги, постери та жанри.",

    eleanshopDesc:
      "Сайт забезпечує зручний процес покупок, дозволяючи користувачам переглядати товари, додавати їх у кошик та переходити до оформлення замовлення.",
    eleanshopHighlights:
      "Сайт створений з використанням HTML для структурування контенту, SCSS для просунутої стилізації та кращої підтримки, JavaScript (ES6+) для обробки інтерактивних елементів та динамічної функціональності, а також Webpack для збірки модулів та оптимізації продуктивності.",

    hellEnglishDesc:
      "Hellen English - це освітній сайт, призначений для вивчення англійської мови. Він має інтуїтивно зрозумілий інтерфейс, структуровані уроки та інтерактивні елементи для захоплюючого навчання.",
    hellEnglishHighlights:
      "Сайт створений з використанням HTML для структурування контенту, SCSS для просунутої стилізації та кращої підтримки, JavaScript (ES6+) для обробки інтерактивних елементів та динамічної функціональності.",

    webStudioDesc:
      "Проект GoIT Markup HW-08 - це адаптивний багатосторінковий сайт, розроблений з використанням сучасних веб-технологій для забезпечення чистого макету, плавної інтерактивності та доступності на різних пристроях.",
    webStudioHighlights:
      "Сайт створений з використанням HTML для структурування контенту, SCSS для просунутої стилізації та кращої підтримки, JavaScript (ES6+) для обробки інтерактивних елементів та динамічної функціональності, а також CSS Flexbox і Grid для адаптивного дизайну.",

    inventoryDesc:
      "Сайт дозволяє користувачам керувати інвентарем, додавати продукти та відстежувати рівень запасів.",
    inventoryHighlights:
      "Сайт створений з використанням React, Redux, HTML, SCSS та Styled Components для чистого та адаптивного дизайну.",

    // Chat and messages
    chatBack: "← Назад",
    chatSupportTitle: "Чат підтримки",
    chatWithUser: "Чат з користувачем",
    chatAdminReply: "Ви відповідаєте як адміністратор",
    chatDeleteChat: "Видалити чат",
    chatLoading: "Завантаження повідомлень...",
    chatNoMessages: "Повідомлень не знайдено",
    chatMessagePlaceholder: "Введіть повідомлення...",
    chatSend: "Надіслати",
    chatDeleteConfirm: "Підтвердження видалення",
    chatDeleteSure: "Ви впевнені, що хочете видалити цей чат?",
    chatDeletePermanent: "Всі повідомлення будуть видалені безповоротно.",
    chatCancel: "Скасувати",
    chatDelete: "Видалити",
    chatDeleting: "Видалення...",

    // User chats
    chatUserChats: "Чати користувачів",
    chatTechSupport: "Технічна підтримка",
    chatNoUsers: "Поки немає користувачів для зв'язку.",
    chatOpenChat: "Відкрити чат",
    chatStartChat: "Почати чат",
    chatAdminMessage:
      "Ви увійшли як адміністратор. Ви можете спілкуватися з усіма користувачами системи.",
    chatNoAdmins:
      "Адміністраторів не знайдено. Будь ласка, зверніться до технічної підтримки.",
    chatAdministrator: "Адміністратор",
    chatOpenSupport: "Відкрити чат підтримки",
    chatContactSupport: "Зв'язатися з підтримкою",
    chatSupportMessage:
      "У цьому розділі ви можете зв'язатися з адміністратором для отримання допомоги.",

    // Contacts
    contactsTitle: "Контакти",
    contactsChats: "Чати",

    // Login and registration
    loginTab: "Вхід",
    registerTab: "Реєстрація",
    loginWithGoogle: "Увійти через Google",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Пароль",
    loginButton: "Увійти",
    registerButton: "Зареєструватися",
    loginError: "Помилка входу",
    registerError: "Помилка реєстрації",
  },
  tr: {
    // Header
    headerHome: "Ana Sayfa",
    headerAbout: "Hakkımda",
    headerProjects: "Projeler",
    headerContacts: "İletişim",
    headerLogout: "Çıkış",
    headerLogin: "Giriş",

    // Home page
    Headername: "SUN4S",
    Maintext: "Merhaba, ben Saftar,",
    Maintexttwo: "Front-End Geliştirici",
    Creative: "YARATICI",
    Experience: "DENEYİM",
    Projects: "PROJELER",
    Development: "GELİŞTİRME",
    Webflow: "WEBFLOW",
    MainExprience: "Uzman bir programcı olmak istiyorum",
    EducationalAward: "KARİYERİME BAŞLADIM",

    // Experience section
    yearsOfExperience: "YIL DENEYİM",
    projectsCompleted: "TAMAMLANAN PROJE",
    happyClients: "MUTLU MÜŞTERİ",

    // Skills section
    mySkills: "BECERİLERİM",
    skillsTitle: "Neler yapabilirim",
    htmlCss: "HTML ve CSS",
    javascript: "JAVASCRIPT",
    react: "REACT",
    nodeJs: "NODE.JS",
    typescript: "TYPESCRIPT",
    git: "GIT",
    figma: "FIGMA",
    responsive: "RESPONSIVE TASARIM",

    // About page
    AboutLastName: "Aliyev",
    AboutName: "Saftar",
    frontendDeveloper: "Frontend Geliştirici",
    buildingModern: "Modern ve duyarlı web uygulamaları geliştiriyorum",
    developerDescription:
      "Temiz, verimli kod ve olağanüstü kullanıcı deneyimleri oluşturmaya odaklanan tutkulu bir geliştirici. Karmaşık problemleri çözmekten ve yeni teknolojiler öğrenmekten keyif alıyorum.",
    experience: "Deneyim",
    education: "Eğitim",
    skills: "Beceriler",

    // Projects
    ProducText: "Baş ürün tasarımcısı ve sanat yönetmeni.",
    AboutTextMain:
      "10 yıldan fazla deneyime sahip profesyonel bir ürün tasarımcısıyım. Amacı olan tasarıma tutkum var. Özel iş ihtiyaçlarınıza ulaşmanıza yardımcı olacak bir tasarımcı arıyorsanız, bunu başarmanıza yardımcı olabilirim.",
    Allwork: "Tümü",
    Design: "Tasarım",
    Branding: "Markalama",
    Figma: "Figma",

    // Services/Skills/Education
    ProducNumber: "ÜRÜN TASARIMCISI (2018 — Şimdi)",
    AwardsNumber: "WEB GELİŞTİRİCİ (2018 — 2019)",
    WoodNumber: "Proje Uzmanı (2015 — 2018)",
    AwardsRegion: "ÖDÜLLER VE BAŞARILAR",
    EducationHeader: "Eğitim ve Yeterlilik",
    EducationRegion: "Becerilerimi öğrendiğim yerler",
    Services: "HİZMETLER",
    HappyCustomer: "TEKNİK BECERİLER",

    // Footer
    FooterLefttext: "© 2024 Tüm hakları saklıdır",

    // Other sections
    contactTitle: "Benimle iletişime geçin",
    contactSubtitle: "Mesaj bırakın",
    messagePlaceholder: "Mesajınız",
    sendButton: "Gönder",
    projectsTitle: "Projeler",
    projectsSubtitle: "Son çalışmalar",
    viewDemo: "Demo",
    viewCode: "Kod",
    technologies: "Kullandığım teknolojiler",

    // Services section
    servicesTitle: "Hizmetlerim",
    servicesSubtitle: "Sizin için neler yapabilirim",
    serviceWebDev: "Web Geliştirici",
    serviceWebDevDesc:
      "Her proje, hevesle kabul ettiğim bir meydan okumadır. İnovatif fikirleri birlikte hayata geçirelim!",
    serviceWebDesign: "Web Tasarımı",
    serviceWebDesignDesc: "Her tasarım güzel ve kullanıcı dostu bir sitedir!",
    serviceUiUx: "UI/UX Tasarımı",
    serviceUiUxDesc: "Her tasarımda, piksellere kadar her şey önemlidir.",
    serviceArtDirection: "Sanat Yönetimi",
    serviceArtDirectionDesc:
      "Sanat olmadan güzel bir web sitesi oluşturamazsınız!",

    // About Me section
    aboutTitle: "Hakkımda",
    aboutSubtitle: "Kendimi tanıtayım",
    aboutBornIn: "DOĞUM YERİ",
    aboutAzerbaijan: "AZERBAYCAN",
    aboutExperience: "DENEYİM",
    aboutExperienceYears: "+3 Yıl",
    aboutLocation: "Konum",
    aboutStockholm: "Stockholm",
    aboutDescription:
      "Ön uç geliştirici olarak, UI/UX kullanıcı arayüzüne sahip web sayfaları oluşturuyorum. Yıllardır deneyimim var ve müşterilerim gerçekleştirilen projelerden memnun.",
    aboutDownloadCV: "CV İndir",

    // Projects section
    usedTechnologies: "Kullanılan teknolojiler",
    frontendCategory: "Ön Yüz",

    // Project descriptions
    filmotekaDesc:
      "Web sitesi, kullanıcıların film aramasına, ayrıntılı açıklamaları görüntülemesine ve favorileri kaydetmesine olanak tanır.",
    filmotekaHighlights:
      "Filmoteka, film bilgilerini aramak ve görüntülemek için bir web uygulamasıdır. Filmler hakkında açıklamalar, derecelendirmeler, posterler ve türler dahil olmak üzere veri almak için The Movie Database (TMDB) API'sini kullanır.",

    eleanshopDesc:
      "Web sitesi, kullanıcıların ürünleri keşfetmelerine, sepete eklemelerine ve ödemeye geçmelerine olanak tanıyan sorunsuz bir alışveriş deneyimi sunar.",
    eleanshopHighlights:
      "Web sitesi, içeriği yapılandırmak için HTML, gelişmiş stil ve daha iyi bakım için SCSS, etkileşimli öğeleri ve dinamik işlevselliği işlemek için JavaScript (ES6+) ve modül paketleme ve performans optimizasyonu için Webpack kullanılarak oluşturulmuştur.",

    hellEnglishDesc:
      "Hellen English, kullanıcıların İngilizce öğrenmelerine yardımcı olmak için tasarlanmış bir eğitim web sitesidir. Sezgisel bir arayüz, yapılandırılmış dersler ve ilgi çekici bir öğrenme deneyimi için etkileşimli öğeler içerir.",
    hellEnglishHighlights:
      "Web sitesi, içeriği yapılandırmak için HTML, gelişmiş stil ve daha iyi bakım için SCSS, etkileşimli öğeleri ve dinamik işlevselliği işlemek için JavaScript (ES6+) kullanılarak oluşturulmuştur.",

    webStudioDesc:
      "GoIT Markup HW-08 projesi, temiz bir düzen, düzgün etkileşim ve farklı cihazlarda erişilebilirlik sağlamak için modern web teknolojileriyle tasarlanmış duyarlı çok sayfalı bir web sitesidir.",
    webStudioHighlights:
      "Web sitesi, içeriği yapılandırmak için HTML, gelişmiş stil ve daha iyi bakım için SCSS, etkileşimli öğeleri ve dinamik işlevselliği işlemek için JavaScript (ES6+) ve duyarlı tasarım için CSS Flexbox ve Grid kullanılarak oluşturulmuştur.",

    inventoryDesc:
      "Web sitesi, kullanıcıların envanteri yönetmesine, ürün eklemesine ve stok seviyelerini izlemesine olanak tanır.",
    inventoryHighlights:
      "Web sitesi, temiz ve duyarlı bir tasarım için React, Redux, HTML, SCSS ve Styled Components kullanılarak oluşturulmuştur.",

    // Chat and messages
    chatBack: "← Geri",
    chatSupportTitle: "Destek Sohbeti",
    chatWithUser: "Kullanıcı ile sohbet",
    chatAdminReply: "Yönetici olarak yanıtlıyorsunuz",
    chatDeleteChat: "Sohbeti Sil",
    chatLoading: "Mesajlar yükleniyor...",
    chatNoMessages: "Mesaj bulunamadı",
    chatMessagePlaceholder: "Mesaj girin...",
    chatSend: "Gönder",
    chatDeleteConfirm: "Silme Onayı",
    chatDeleteSure: "Bu sohbeti silmek istediğinizden emin misiniz?",
    chatDeletePermanent: "Tüm mesajlar kalıcı olarak silinecektir.",
    chatCancel: "İptal",
    chatDelete: "Sil",
    chatDeleting: "Siliniyor...",

    // User chats
    chatUserChats: "Kullanıcı Sohbetleri",
    chatTechSupport: "Teknik Destek",
    chatNoUsers: "Henüz bağlanacak kullanıcı yok.",
    chatOpenChat: "Sohbeti Aç",
    chatStartChat: "Sohbet Başlat",
    chatAdminMessage:
      "Yönetici olarak giriş yaptınız. Tüm sistem kullanıcılarıyla iletişim kurabilirsiniz.",
    chatNoAdmins: "Yönetici bulunamadı. Lütfen teknik desteğe başvurun.",
    chatAdministrator: "Yönetici",
    chatOpenSupport: "Destek Sohbetini Aç",
    chatContactSupport: "Destek ile İletişime Geç",
    chatSupportMessage:
      "Bu bölümde yardım almak için yönetici ile iletişime geçebilirsiniz.",

    // Contacts
    contactsTitle: "Kişiler",
    contactsChats: "Sohbetler",

    // Login and registration
    loginTab: "Giriş",
    registerTab: "Kayıt",
    loginWithGoogle: "Google ile giriş yap",
    emailPlaceholder: "E-posta",
    passwordPlaceholder: "Parola",
    loginButton: "Giriş Yap",
    registerButton: "Kaydol",
    loginError: "Giriş hatası",
    registerError: "Kayıt hatası",
  },
};

export const startOfWarDate = new Date(2022, 1, 24);
export const endOfWarDate = new Date(2022, 3, 29);
